import { useTranslation } from 'react-i18next';
import './SpendingCapNotice.css';

// Explains why the AI actions next to it are disabled (#208). Every screen that spends AI
// shows the same sentence, so a capped user meets one explanation rather than a different
// guess on each screen. Render it only when the cap actually holds (see useSpendingCap).
function SpendingCapNotice() {
  const { t } = useTranslation();

  return (
    <p className="spending-cap-notice" role="status">
      {t('spendingCap.disabled')}
    </p>
  );
}

export default SpendingCapNotice;
